import { UserMetadata } from '../../@types/User';
import backendAPIClient from '../apiClient';

export default function updateUserMetadata(metadata: UserMetadata) {
    return backendAPIClient
        .put(`users/frontegg/me/metadata`, metadata)
        .then((result) => result.data);
}
